import React, { useState, useEffect } from 'react'
import { InvestmentCard } from 'src/components/Global/Cards/Cards'
import { ExploreInvestmentWrapper } from './exploreStyle'
import { useTypedSelector } from 'src/redux/index'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'

const Explore = () => {
  const investmentData = useTypedSelector((state) => state.invest.all.plans)

  const [id, setId] = useState()

  let location = useLocation()

  return (
    <ExploreInvestmentWrapper>
      {investmentData?.map((item: any) => {
        return (
          <div
            className={`investment_card_container ${
              item.sold_out ? 'sold' : 'active'
            }`}
            key={item.id}
          >
            <Link
              to={item.sold_out ? '' : `/invest-information/${item.id}`}
              key={item.id}
              state={{ backgroundLocation: location }}
              style={{
                textDecoration: 'none',
                color: '#00327C',
              }}
              className={item.sold_out ? 'sold_investment' : ''}
            >
              <div
                className="investmentCard"
                key={item.id}
                onClick={(e) => {
                  setId(id)
                }}
              >
                <div className="card_header">
                  <img src={item.image} alt="" className="card_img" />
                  <div className={`card_type ${item.sold_out ? 'sold' : ''}`}>
                    <p>{item.sold_out ? 'Sold Out' : 'NEW'}</p>
                  </div>
                  {/* <div className="card_type">
                    <p>new</p>
                  </div> */}
                </div>

                <div className="card_body">
                  <div className="title">
                    <h3>{item.plan_name.toLowerCase()}</h3>
                  </div>
                  <div className="profit">
                    <p className="profit_text">
                      <span className="roi">{item.roi}%</span> return in{' '}
                      {item.duration} months
                    </p>
                  </div>

                  <div className="sector_amount_wrapper">
                    <div className="sector">
                      <p className="sector-text">Sector</p>
                      <p className="sector-amount">{item.sector}</p>
                    </div>
                    <div className="amount">
                      <p className="sector-text">Min.Amount</p>
                      <p className="sector-amount">{item.minimum_amount}</p>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        )
      })}
    </ExploreInvestmentWrapper>
  )
}

export { Explore }
